import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import { getDataAttribute } from 'epic-common/src/browser';

@pureRender
class FooterLinks extends React.Component {
    static propTypes = {
        links: PropTypes.array
    };

    onClick = (e) => {
        const index = getDataAttribute(e.currentTarget, 'index');
        const link = this.props.links[index];

        if (link && link.onClick && typeof link.onClick === 'function') {
            link.onClick(e);
        }
    };

    renderLinks = (links, startingIndex) => {
        if (!links) return [];
        return links.map((link, i) => {
            return (
                <li key={`item-${link.title}`}>
                    <a
                        onClick={this.onClick}
                        href={link.href || '#'}
                        target={link.target}
                        data-index={startingIndex + i}
                        className={`text-color accent-color-hover ${!link.href ? 'cursor-default' : ''}`}>
                        {link.title}
                    </a>
                </li>
            );
        });
    };

    render() {
        let links = this.props.links || [];
        if (links && typeof links.asMutable === 'function') {
            links = links.asMutable();
        }

        let one = [];
        let two = [];
        let three = [];

        // more than 4 items split in half
        if (links.length >= 4 && links.length < 9) {
            const split = Math.ceil(links.length / 2);
            one = links.slice(0, split);
            two = links.slice(split, links.length);
        } else if (links.length > 8) {
            let split = Math.ceil(links.length / 3);
            one = links.slice(0, split);
            split = Math.ceil(links.length * 0.666);
            two = links.slice(one.length, split);
            three = links.slice(split, links.length);
        } else {
            one = links;
        }

        return (
            <div className={`col-xs-12 col-sm-8 col-md-7 col-lg-6 ${one.length ? 'one' : ''} ${two.length ? 'two' : ''} ${three.length ? 'three' : ''}`}>
                {one && one.length > 0 ? (
                    <ul className="footerLinks first-column">
                        { this.renderLinks(one, 0) }
                    </ul>) : ''}
                {two && two.length > 0 ? (
                    <ul className="footerLinks second-column">
                        { this.renderLinks(two, one.length) }
                    </ul>) : ''}
                {three && three.length > 0 ? (
                    <ul className="footerLinks third-column">
                        { this.renderLinks(three, one.length + two.length) }
                    </ul>) : ''}
            </div>
        );
    }
}

export default FooterLinks;



// WEBPACK FOOTER //
// ./app/scripts/components/links/FooterLinks.js